"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./style.sass");
var icons_1 = __importDefault(require("../../theme/icons"));
var Card = function (_a) {
    var className = _a.className, text = _a.text, icon = _a.icon, iconUrl = _a.iconUrl, onClick = _a.onClick;
    return (react_1.default.createElement("div", { className: "card-wrapper ".concat(className) },
        react_1.default.createElement("button", { className: "card-button", onClick: onClick },
            react_1.default.createElement("div", { className: "image-wrapper" }, iconUrl ? (react_1.default.createElement("img", { src: icon, className: "image-wrapper", style: { marginBottom: 0 } })) : (react_1.default.createElement(icons_1.default, { name: icon, width: 60, height: 60, className: "icon" }))),
            react_1.default.createElement("span", { className: "card-text" }, text))));
};
exports.default = Card;
